import { DocumentActions, DocumentStore } from "../document/reflux/document_store";

import InputValidator from './input_validator'

export default class DocumentMetadataValidator {
	static validate(metadataInputsProps, modalId, inputDocumentId) {
		const action = (errors) => this.handleSetMetadataValidationErrors(modalId, inputDocumentId, errors);
		const assignedMetadataProps = this.assignValueToMetadataInputProps(metadataInputsProps, modalId, inputDocumentId);
		const errorsInputRequired = InputValidator.validate(assignedMetadataProps);

		action(errorsInputRequired);

		return !Object.keys(errorsInputRequired).length
	}

	static handleSetMetadataValidationErrors(modalId, inputDocumentId, errors) {
		const errorsWithTemplateKey = this.generateNewErrorsWithTemplateKey(errors, modalId);
		DocumentActions.setMetadataValidationErrors(inputDocumentId, errorsWithTemplateKey);
	}

	static generateNewErrorsWithTemplateKey(errors, modalId) {
		var objErrors = {};

		for (var key in errors) {
			objErrors[`${key}_${modalId}_templateField`] = errors[key];
		}

		return objErrors;
	}

	static assignValueToMetadataInputProps(metadataInputsProps, modalId, inputDocumentId) {
		const storeItem = DocumentStore.store[inputDocumentId];

		if(storeItem.submitData[modalId] === undefined){
			let submitMetadataValues = undefined;
			let arrMetadataInputsProps = [];
			let objMetadataInputsProps = {};

			arrMetadataInputsProps
				.map(tuple => this.createValueAndPropsPair(tuple, submitMetadataValues))
				.map(this.mergeMetadataValueWithProps)
				.map(metadataProps => objMetadataInputsProps[metadataProps.name] = metadataProps);

			return objMetadataInputsProps;

		} else {
			const { metadata: submitMetadataValues } = storeItem.submitData[modalId];
			let arrMetadataInputsProps = [];
			let objMetadataInputsProps = {};

			for (var key in metadataInputsProps) {
				arrMetadataInputsProps.push([key, metadataInputsProps[key]]);
			}

			arrMetadataInputsProps
				.map(tuple => this.createValueAndPropsPair(tuple, submitMetadataValues))
				.map(this.mergeMetadataValueWithProps)
				.map(metadataProps => objMetadataInputsProps[metadataProps.name] = metadataProps);

			return objMetadataInputsProps;
		}
	}

	static mergeMetadataValueWithProps([metadataInputValue, metadataInputProps]) {
		return Object.assign({}, metadataInputProps, {value: metadataInputValue});
	}

	static createValueAndPropsPair([metadataInputName, metadataInputProps], submitMetadataValues) {
		const metadataInputValue = this.findMetadataValueByName(submitMetadataValues, metadataInputName);
		return [metadataInputValue, metadataInputProps];
	}

	static findMetadataValueByName(submitMetadataValues, metadataInputName) {
		var foundSubmitMetadata;

		if (submitMetadataValues) {
			for (let cont = 0, len = submitMetadataValues.length; cont < len; cont++) {
				if (submitMetadataValues[cont].id === metadataInputName) {
					foundSubmitMetadata = submitMetadataValues[cont];
					break;
				}
			}
		}

		return foundSubmitMetadata ? foundSubmitMetadata.value : null;
	}
}
